module.exports = __webpack_public_path__ + "static/media/AppCenter_ai_speech.3409af9e.jpg";